import type { FieldErrors, FieldValues } from "react-hook-form";

export function flattenValidationErrors<TFieldValues extends FieldValues>(
  errors: FieldErrors<TFieldValues>,
  path = ""
): string[] {

  console.log(errors);
  const lines: string[] = [];

  for (const [key, rawValue] of Object.entries(errors)) {
    const currentPath = path ? `${path}.${key}` : key;

    if (!rawValue || typeof rawValue !== "object") {
      continue;
    }

    const value = rawValue as {
      message?: unknown;
      type?: unknown;
      types?: Record<string, unknown>;
      ref?: unknown;
      name?: unknown;
      root?: unknown;
      [nestedKey: string]: unknown;
    };

    if (typeof value.message === "string" && value.message.length > 0) {
      lines.push(`${currentPath}`);
    }

    if (value.types && typeof value.types === "object") {
      for (const nestedMessage of Object.values(value.types)) {
        if (nestedMessage != null && String(nestedMessage).length > 0) {
          lines.push(`${currentPath}: ${String(nestedMessage)}`);
        }
      }
    }

    for (const [nestedKey, nestedValue] of Object.entries(value)) {
      if (["message", "type", "types", "ref", "name", "root"].includes(nestedKey)) {
        continue;
      }

      if (!nestedValue || typeof nestedValue !== "object") {
        continue;
      }

      lines.push(
        ...flattenValidationErrors(
          { [nestedKey]: nestedValue } as FieldErrors<TFieldValues>,
          currentPath
        )
      );
    }
  }

  return lines;
}
